import axios from 'axios'
axios.defaults.withCredentials = true;
axios.defaults.baseUrl = 'http://localhost:8000'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default {
    
    actions:{

        FazerLogin (context, value) {
         localStorage.setItem('access_token',value)
         localStorage.setItem('logado',true)
          context.commit('SET_DADOS_ALUNO', value)

        // axios.get('http://localhost:8000/sanctum/csrf-cookie').then(response => {

        // axios.post('http://localhost:8000/login',
        // {
        //   password:value.password,
        //   email:value.email
        // })
        //   .then(response => {
        //     console.log(response)
          
        //   })
        //   .catch((error) => {
        //     console.log(error.response.data.message)
        //   }).finally( () => {
        //         //   context.commit('PRELOADER_MUDAR', false)
        //   })
         
        //   });

       },
    
        PegarUser(){

            axios.get('http://localhost:8000/user',
          
          )
            .then(response => {
                console.log(response)
            })
            .catch((error) => {
              console.log(error.response.data.message)
            }).finally( () => {
                  //   context.commit('PRELOADER_MUDAR', false)
            })

       },

    },
    getters:{

    },
    mutations:{
        SET_DADOS_ALUNO (state, value) {
            state.User =  value
            state.logado = true
          },

    },
    state:{
      User: {},
      logado:''

    },
}